import { render } from "./VehicleManage.vue?vue&type=template&id=62d20723&scoped=true&ts=true"
import script from "./VehicleManage.vue?vue&type=script&lang=tsx"
export * from "./VehicleManage.vue?vue&type=script&lang=tsx"

import "./VehicleManage.vue?vue&type=style&index=0&id=62d20723&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d20723"]])

export default __exports__